/**
 * useRecordsApi — convenience hook for the Records Management module.
 *
 * Wraps useApi with consistent abort plumbing so callers don't have to
 * reach into useApi directly for every fetch.
 */

import { useApi } from '@/modules/RAO/hooks/useApi';

export function useRecordsApi() {
  return useApi();
}
